import {AppShell} from '@dbp-toolkit/app-shell';
import * as commonUtils from '@dbp-toolkit/common/utils';

commonUtils.defineCustomElement('dbp-authentic-document', AppShell);
